import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=28c5065e&scoped=true&"
import script from "./landing.vue?vue&type=script&lang=js&"
export * from "./landing.vue?vue&type=script&lang=js&"
import style0 from "./landing.vue?vue&type=style&index=0&id=28c5065e&prod&lang=css&"
import style1 from "./landing.vue?vue&type=style&index=1&id=28c5065e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5065e",
  null
  
)

export default component.exports